export const getParams = (name) => {
  var reg = new RegExp("[?&]" + name + "=([^&#]+)"),
    param = window.location.href.match(reg);
  return param ? decodeURIComponent(param[1]) : null;
};

// 检测是否为ie，是则返回ie版本
export const detectIEEdge = () => {
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf("MSIE ");
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  }

  var trident = ua.indexOf("Trident/");
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf("rv:");
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
  }

  var edge = ua.indexOf("Edge/");
  if (edge > 0) {
    // Edge => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
  }

  // other browser
  return false;
};
// 获取当前域名
export const getDomainName = (name) => {
  return window.location.host === name;
};
